import { render, staticRenderFns } from "./BranchCommission.vue?vue&type=template&id=64c60003"
import script from "./BranchCommission.vue?vue&type=script&lang=js"
export * from "./BranchCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports